import * as i0 from '@angular/core';
import { Directive, Input, NgModule } from '@angular/core';
import { AbstractTuiController } from '@taiga-ui/cdk';

class TuiModeDirective extends AbstractTuiController {
    constructor() {
        super(...arguments);
        this.mode = null;
    }
}
TuiModeDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiModeDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
TuiModeDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: TuiModeDirective, selector: "[tuiMode]", inputs: { mode: ["tuiMode", "mode"] }, usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiModeDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[tuiMode]',
                }]
        }], propDecorators: { mode: [{
                type: Input,
                args: ['tuiMode']
            }] } });

class TuiModeModule {
}
TuiModeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiModeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TuiModeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiModeModule, declarations: [TuiModeDirective], exports: [TuiModeDirective] });
TuiModeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiModeModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiModeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TuiModeDirective],
                    exports: [TuiModeDirective],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TuiModeDirective, TuiModeModule };
